import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '@awp/quote/models';

export interface ErrorModel {
  code?: string;
  message?: string;
  section?: string;
  httpStatus?: number;
  url?: string;
  apiError?: ApiError;
  requestEntity?: any;
}

export function createErrorModel({ err, section, message, requestEntity }: { err: any; section?: string; message?: string; requestEntity?: any }): ErrorModel {

  if (err instanceof HttpErrorResponse) {
    switch ((<HttpErrorResponse>err).status) {
      case 401: return { code: 'UNAUTHORISED', message: 'Unauthorised', section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity };
      case 400: return { code: 'BAD_REQUEST', message: 'Invalid Request', section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity };
      case 404: return { code: 'NOT_FOUND', message: 'Not found', section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity };
      case 422: return { code: getErrorCodeFromResponse(err) , message: 'Unprocessable Entity', section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity };
      case 500: return { code: 'INTERNAL_ERROR', message: 'Internal Server Error', section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity };
      default:  return { code: 'UNKNOWN_ERROR', message: 'Unknown Server Error', section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity };
    }
  }

  if (err != null && err.code != null) {
    return {
      code: err.code,
      message: message,
      section,
      httpStatus: null,
      url: null,
      apiError: err,
      requestEntity
    }
  };

  return {
    code: 'UNKNOWN_ERROR',
    message: message || 'Unknown Server Error',
    section,
    httpStatus: err != null ? err.status : null,
    url: err != null ? err.url : null,
    apiError: err,
    requestEntity
  };
}

function getErrorCodeFromResponse(errorResponse: HttpErrorResponse): string {
  var messageCode = errorResponse.error && errorResponse.error.messageCodes && errorResponse.error.messageCodes.length > 0 && errorResponse.error.messageCodes[0];
  return messageCode? messageCode: 'UNPROCESSABLE_ENTITY';
}
